import React, { useRef } from 'react';

import {
  useTransition,
  useSpring,
  useChain,
  config,
  ReactSpringHook,
  animated,
} from 'react-spring';
// import { paths } from '@routes/paths';

import { getPaths } from '../../../../../paths';

import { NavLink } from 'react-router-dom';
import { Icon } from '@components/generic/Icon';
import { Switch } from '@components/generic/Switch';
import { useTheme } from '@hooks/theme';
import { useAuth } from '@hooks/auth';
import avatar from './assets/avatar.jpg';

import { Container, Nav, Li, Header } from './styles';

export const Sidebar: React.FC<{
  showSideBar: boolean;
  closeSidebar(): void;
}> = ({ showSideBar, closeSidebar }) => {
  const navRef = useRef<ReactSpringHook>(null);
  const liRef = useRef<ReactSpringHook>(null);
  const fadesRef = useRef<ReactSpringHook>(null);

  const { theme, changeTheme } = useTheme();
  const { signOut, user } = useAuth();

  const dataPaths = getPaths(user.groupUser);

  const springProps = useSpring({
    ref: navRef,
    config: config.default,
    from: { left: '-100%' },
    to: { left: showSideBar ? '0' : '-100%' },
  });

  const fades = useSpring({
    ref: fadesRef,
    to: {
      opacity: showSideBar ? 1 : 0,
      transform: showSideBar ? 'translateY(0px)' : 'translateY(20px)',
    },
  });

  const liTransitions = useTransition(
    showSideBar ? dataPaths : [],
    (item) => item.name,
    {
      ref: liRef,
      trail: 400 / dataPaths.length,
      from: { opacity: 0, transform: 'translateY(20px)' },
      enter: { opacity: 1, transform: 'translateY(0)' },
      leave: { opacity: 0, transform: 'translateY(20px)' },
    },
  );

  useChain(
    showSideBar ? [navRef, liRef, fadesRef] : [liRef, navRef, fadesRef],
    [0, showSideBar ? 0.4 : 0.6, 0],
  );

  return (
    <Container style={springProps}>
      <Nav>
        <button type="button" className="close" onClick={closeSidebar}>
          <Icon name="close" color="white" size="lg" />
        </button>
        <Header style={fades}>
          <img src={avatar} alt="avatar" />
          <p className="p2 ifpa-bold">{user.name}</p>
        </Header>
        <animated.span
          style={{ ...fades, margin: '2rem auto' }}
          className="hr"
        />
        <ul>
          {liTransitions.map(({ item, key, props }) => (
            <Li key={key} style={props}>
              <NavLink to={item.path}>
                <div>
                  <Icon name={item.icon} color="textWhite" />
                  <p className="p1 ifpa-medium">{item.name}</p>
                </div>
              </NavLink>
            </Li>
          ))}
        </ul>

        <animated.div style={fades} className="toggleTheme">
          <Switch checked={theme !== 'light'} onClick={changeTheme} />
          <p className="p1 ifpa-medium">Modo Escuro</p>
        </animated.div>
        <animated.span
          style={{ ...fades, margin: '1rem auto' }}
          className="hr"
        />
        <animated.button
          style={fades}
          className="signOutButton"
          type="button"
          onClick={signOut}
        >
          <Icon name="logout" color="textWhite" />
          <p className="p1 ifpa-medium">Sair</p>
        </animated.button>
      </Nav>
    </Container>
  );
};
